import React, {Component} from 'react';

import AlbumsForm from '../mixins/AlbumsForm';


export default class CreateAlbum extends Component {
    render() {
        return (
            <AlbumsForm album={{}}/>
        );
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/CreateAlbum.js